import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const couponRoutes: RouteRecordRaw[] = [
  {
    path: '/coupons',
    name: ROUTES.COUPONS,
    component: () => import('@/modules/coupons/views/CouponListing.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.COUPONS_VIEW }
  },
  {
    path: '/coupons/:id',
    name: ROUTES.COUPON_DETAILS,
    component: () => import('@/modules/coupons/views/CouponDetails.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.COUPONS_VIEW }
  }
]
